module.exports = __webpack_public_path__ + "static/media/preventivo_rojo.b39eac8d.svg";